import { makeStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import { getJWT } from "../../../../Helpers";
import axios from "axios";
import { UsersManagementProps } from "../../../../pages/v2/UsersPage";
import { logger } from "../../../../services/logger";
import { Button } from "@mui/material";
import { ViewUserManagement } from "@backend-types";

const useStyles = makeStyles((theme) => ({
  newPosOfDialog: {
    paddingTop: "32px",
    paddingBottom: "32px",
    paddingLeft: "40px",
    paddingRight: "40px",
    width: "35%",
    minWidth: "400px",
    minHeight: "200px",
    backgroundColor: "#FFF8F2",
    border: "1px solid #FD8211",
    boxShadow: "0px 3px 20px #00000014",
    borderRadius: "20px",
  },
  dialogTitle: {
    fontSize: "18px",
    fontWeight: "bold",
    color: "#191919",
    marginBottom: "24px",
  },
  dialogText: {
    fontSize: "15px",
    color: "#5D5D5D",
    marginBottom: "33px",
  },
  label: {
    fontWeight: "bold",
  },
  buttonWrapper: {
    display: "flex",
    justifyContent: "flex-start",
    gap: "16px",
  },
}));

export interface UserDeletePromptProps extends UsersManagementProps {
  promptOpen: boolean;
  promptOnClose: () => void;
  user: ViewUserManagement | undefined;
}

export const UserDeletePrompt = (props: UserDeletePromptProps) => {
  const classes = useStyles();

  const { promptOnClose, promptOpen, user } = props;

  const deleteUser = (user: ViewUserManagement | undefined) => {
    if (!user) return;
    const api = process.env.REACT_APP_BACKEND_API!;
    const id = props?.user?.id;
    const email = props?.user?.email;

    if (!email || !id) return;
    const idUrlEncode = encodeURIComponent(id);
    const emailUrlEncode = encodeURIComponent(email);
    const cognitoUserEndpoint =
      api + `/cognito-users?id=${idUrlEncode}&email=${emailUrlEncode}`;
    getJWT().then((jwt) => {
      axios
        .delete(cognitoUserEndpoint, {
          headers: { Authorization: `Bearer ${jwt}` },
        })
        .then((res) => {
          const message = `Delete user, ${email}, result: Success.`;
          props.onDelete({ message, severity: "success" });
        })
        .catch((err) => {
          logger.error(err);
          const message = `Delete user, ${email}, result: Failed.`;
          props.onDelete({ message, severity: "error" });
        });
    });
    promptOnClose();
  };

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      classes={{
        paper: classes.newPosOfDialog,
      }}
      onClose={promptOnClose}
      aria-labelledby="simple-dialog-title"
      open={promptOpen}>
      <div className={classes.dialogTitle}>
        Are you sure you want to delete the following user? This will also delete all of
        the user's historical data.
      </div>
      <div className={classes.dialogText}>
        <p>
          <span className={classes.label}>Email:</span> {user?.email}
        </p>
        <p>
          <span className={classes.label}>First Name:</span> {user?.first_name}
        </p>
        <p>
          <span className={classes.label}>Last Name:</span> {user?.last_name}
        </p>
      </div>
      <div className={classes.buttonWrapper}>
        <Button variant="outlined" size="medium" onClick={promptOnClose}>
          No
        </Button>
        <Button variant="contained" size="medium" onClick={(event) => deleteUser(user)}>
          Yes, delete this user
        </Button>
      </div>
    </Dialog>
  );
};
